import { Spinner } from "@/shared/components/ui";
import {
  selectHasPaid,
  selectIsAuthenticated,
  selectIsAuthenticating,
} from "@/store/slices/auth";
import {
  canUpgradeToTeacher,
  hasActiveCheckout as selectHasActiveCheckout,
} from "@/store/slices/planType";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

// /**
//  * Wraps the payment funnel: /payment-methods, /credit-card, /bitcoin.
//  *
//  * - session check pending → hold (prevents wrong redirect on refresh)
//  * - logged out            → /login
//  * - already paid          → /courses  ← this is what neutralizes the back
//  *                           button, bfcache restores, and deep links after
//  *                           a successful purchase
//  */
// export const RequireUnpaid = () => {
//   const isAuthenticating = useSelector(selectIsAuthenticating);
//   const isAuthenticated = useSelector(selectIsAuthenticated);
//   const hasPaid = useSelector(selectHasPaid);

//   const canUpgrade = useSelector(canUpgradeToTeacher);
//  //const hasActiveCheckout = useSelector(hasActiveCheckout);
//   if (isAuthenticating) return <Spinner size="md" />;
//   if (!isAuthenticated) return <Navigate to="/login" replace />;
//   // Unpaid: always in. Paid: needs a live intent AND something left to
//   // buy. A teacher fails canUpgrade, so even a stale persisted intent
//   // (paid on ElanPay's hosted page, closed the tab before the success
//   // redirect ever ran) can never reopen the funnel for them.
//   const mayEnterFunnel = !hasPaid || (hasActiveCheckout && canUpgrade);
//   if (!mayEnterFunnel) {
//     return <Navigate to="/courses" replace />;
//   }
//   if (hasPaid && !hasActiveCheckout) return <Navigate to="/courses" replace />;

//   return <Outlet />;
// };;
/**
 * Wraps the funnel: /payment/methods, /payment/methods/credit-card,
 * /payment/methods/btc.
 *
 * The rule this encodes:
 *   unpaid user               → funnel always open (scenario i)
 *   paid student, no intent   → bounced to /courses. Back button,
 *                               bfcache, deep links: all dead ends.
 *   paid student, WITH intent → allowed in. Intent only exists after a
 *                               deliberate initiatePlanUpgrade dispatch
 *                               (the upgrade button on /courses).
 *   TEACHER (top plan)        → bounced UNCONDITIONALLY, intent or not.
 *                               Nothing left to buy means no payment
 *                               page is ever rendered for them again.
 *
 * Intent lives in Redux (checkoutSource), NOT location.state — history
 * entries keep their state, so the back button could resurrect a
 * location.state flag after purchase. It cannot resurrect Redux.
 */
export const RequireUnpaid = () => {
  const isAuthenticating = useSelector(selectIsAuthenticating);
  const isAuthenticated = useSelector(selectIsAuthenticated);
  const hasPaid = useSelector(selectHasPaid);
  const hasActiveCheckout = useSelector(selectHasActiveCheckout);
  const canUpgrade = useSelector(canUpgradeToTeacher);

  if (isAuthenticating) return <Spinner size="md" />;
  if (!isAuthenticated) return <Navigate to="/login" replace />;

  // Unpaid: always in. Paid: needs a live intent AND something left to
  // buy. A teacher fails canUpgrade, so even a stale persisted intent
  // (paid on ElanPay's hosted page, closed the tab before the success
  // redirect ever ran) can never reopen the funnel for them.
  const mayEnterFunnel = !hasPaid || (hasActiveCheckout && canUpgrade);
  if (!mayEnterFunnel) {
    return <Navigate to="/courses" replace />;
  }

  return <Outlet />;
};
